// extracted by mini-css-extract-plugin
export var circle = "_eo-1";
export var exitConfirmationModal = "_eo-5";
export var iframe = "_eo-0";
export var offline = "_eo-3";
export var online = "_eo-2";
export var workstationSelectError = "_eo-4";